<nav class="breadcrumb-nav mb-2" aria-label="Breadcrumb">
  <ol class="breadcrumb-list">
    <li class="breadcrumb-item dark:text-dark-text-tertiary">
      <a class="breadcrumb-link dark:text-dark-text-secondary dark:hover:text-dark-text" routerLink="/dashboard">
        <i class="iconify" data-icon="solar:home-2-broken"></i>
      </a>
      <span class="breadcrumb-separator" aria-hidden="true">
        <mat-icon class="breadcrumb-chevron">chevron_right</mat-icon>
      </span>
    </li>

    @for (item of effectiveItems(); track item.label; let last = $last) {
      <li class="breadcrumb-item" [class.breadcrumb-item--current]="last">
        @if (item.url && !last) {
          <a [routerLink]="item.url" class="breadcrumb-link dark:text-dark-text-secondary dark:hover:text-dark-text">
            {{ item.label | translate }}
          </a>
        } @else {
          <span class="breadcrumb-current dark:text-dark-text">{{ item.label | translate }}</span>
        }
        @if (!last) {
          <span class="breadcrumb-separator dark:text-dark-text-tertiary" aria-hidden="true">
            <mat-icon class="breadcrumb-chevron">chevron_right</mat-icon>
          </span>
        }
      </li>
    }
  </ol>
</nav>
